import { formatCurrency } from '@/utils/function'
import { Typogaphy } from 'vnetwork-ui'

interface CellPriceProps {
    price: number
    subfix?: string
    className?: string
    currency?: string
}

const CellPrice: React.FC<CellPriceProps> = ({
    price = 0,
    subfix,
    className,
    currency,
}) => {
    return (
        <div className="flex w-full h-full items-center justify-end">
            <Typogaphy className={className} size="small">
                {formatCurrency(price, currency || 'VND')}
                {subfix && `/${subfix}`}
            </Typogaphy>
        </div>
    )
}

export default CellPrice
